import { render, staticRenderFns } from "./geneChildDrugs.vue?vue&type=template&id=f55b5848&scoped=true"
import script from "./geneChildDrugs.vue?vue&type=script&lang=js"
export * from "./geneChildDrugs.vue?vue&type=script&lang=js"
import style0 from "./geneChildDrugs.vue?vue&type=style&index=0&id=f55b5848&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55b5848",
  null
  
)

export default component.exports